module.exports = __webpack_public_path__ + "img/RETRIEVE.a6a6c40a.png";